import { useLocale } from "@acto/web-common/locales";
import "dayjs/locale/de";
import "dayjs/locale/en";
import dayjs from "dayjs";

/**
 * Sets dayjs's global locale to the user's locale during render, so every child formats
 * dates in it from its first render.
 */
export function DayjsLocaleProvider({ children }: { children: React.ReactNode }) {
  const { locale } = useLocale();
  dayjs.locale(locale === "en-US" ? "en" : "de");
  return children;
}
